import { Divider, Paper, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import ResultsTable from './ResultsTable/ResultsTable';

const ResultsOverview = (): JSX.Element => {
  const dispatch = useAppDispatch();

  return (
    <Paper elevation={2} sx={{ px: 2, py: 2 }}>
      <Stack direction={'column'} spacing={1}>
        <Typography variant={'h4'}>
          <Trans>Results</Trans>
        </Typography>
        <Divider />
        <ResultsTable />
      </Stack>
    </Paper>
  );
};

export default ResultsOverview;
